// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_4i-4";
export var collapsed = "_4i-1";
export var headerBar = "_4i-0";
export var leftHeaderContent = "_4i-3";
export var subjectContainer = "_4i-2";